// extracted by mini-css-extract-plugin
export default {"tabletImg":"TN","desktopImg":"UN","mobileImg":"VN","backgroundImage":"WN","content":"XN","rtbLeft":"YN","rtbRight":"ZN","imageContainer":"aO","rtbBox":"bO","line":"cO"};
    if(module.hot) {
      // 1714654894290
      var cssReload = require("../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  